import type {DocumentLayouts} from './types';

export const DOCUMENT_LAYOUTS: DocumentLayouts = {
  'AD-passport-prado': [
    ['mrz', 4.6, 80.6, 90.5, 12.7, 2],
    ['photo', 2.2, 20.2, 26.6, 49.4],
    ['ghost', 85, 15.9, 9.6, 16.8],
    ['text', 31, 6, 65, 55.5, 2],
  ],
  'AE-id-back': [
    ['mrz', 5.4, 69.7, 89.1, 22.2, 3],
    ['text', 4, 26, 38, 13, 2],
    ['text', 3, 43, 38, 13, 2],
    ['text', 69, 44, 28, 14, 2],
    ['text', 60, 11, 38, 9, 1],
    ['text', 45, 26, 19, 13, 2],
    ['text', 4, 10, 30, 5, 1],
  ],
  'AE-passport': [
    ['mrz', 7.9, 82.8, 88.4, 9.4, 2],
    ['photo', 8, 26, 25, 40],
    ['text', 36, 35, 26, 38, 7],
    ['text', 36, 13, 43, 16, 3],
    ['text', 76, 32, 22, 40, 8],
    ['text', 9, 13, 10, 8, 1],
  ],
  'AL-id-back': [
    ['mrz', 7, 68.2, 86.8, 19.8, 3],
    ['chip', 10, 33, 15, 18],
  ],
  'AL-passport': [
    ['mrz', 5.6, 82.2, 88.5, 8.9, 2],
    ['photo', 7, 17, 26, 40],
    ['ghost', 80, 32, 10, 17],
    ['text', 36, 12, 36, 52, 10],
    ['text', 75, 52, 18, 15, 3],
    ['text', 75, 14, 18, 6, 1],
    ['text', 7, 3, 15, 8, 1],
  ],
  'AM-passport-prado': [
    ['mrz', 4.4, 79.6, 90.2, 13.5, 2],
    ['photo', 3, 24.8, 25.6, 47.5],
    ['text', 32.2, 10.5, 63.8, 56.7, 14],
  ],
  'AR-id-back': [
    ['mrz', 6.5, 68.2, 87.8, 19.3, 3],
    ['ghost', 17, 20, 9, 17],
    ['text', 29, 7, 36, 17, 3],
    ['text', 33, 48, 38, 8, 1],
  ],
  'AR-passport': [
    ['mrz', 5.4, 77.4, 89.6, 9.5, 2],
    ['photo', 4, 23, 28, 48],
    ['ghost', 81, 26, 13, 19],
    ['text', 35, 10, 39, 60, 12],
    ['text', 4, 5, 28, 8, 1],
    ['text', 81, 60, 12, 4, 1],
  ],
  'AT-id-back': [
    ['mrz', 6.9, 68.8, 84.4, 19.2, 3],
    ['qr', 66, 8, 28, 35],
    ['text', 2, 6, 27, 40, 6],
    ['text', 50, 8, 13, 8, 1],
  ],
  'AT-passport': [
    ['mrz', 5.9, 79.9, 88.6, 9.8, 2],
    ['photo', 3, 22, 30, 48],
    ['ghost', 88, 18, 9, 22],
    ['text', 36, 20, 45, 48, 9],
    ['text', 33, 6, 52, 6, 1],
    ['text', 4, 6, 17, 7, 1],
  ],
  'AU-passport': [
    ['mrz', 4.4, 79.9, 89, 10.6, 2],
    ['photo', 3, 23, 26, 50],
    ['ghost', 74, 32, 10, 18],
    ['text', 33, 12, 38, 64, 12],
    ['text', 77, 12, 19, 7, 1],
    ['text', 47, 4, 15, 5, 1],
    ['text', 4, 14, 15, 6, 1],
  ],
  'AZ-passport': [
    ['mrz', 5, 82.6, 93.1, 10.7, 2],
    ['photo', 7, 25, 25, 38],
    ['ghost', 85, 19, 9, 20],
    ['text', 35, 20, 43, 50, 10],
    ['text', 30, 6, 48, 11, 2],
  ],
  'BA-id-back': [
    ['mrz', 5.3, 69, 89.8, 21.3, 3],
    ['barcode', 69, 43, 27, 10],
    ['text', 4, 9, 40, 43, 8],
    ['text', 64, 9, 20, 31, 5],
  ],
  'BA-passport': [
    ['mrz', 5.6, 79.7, 88.9, 11.2, 2],
    ['photo', 5, 20, 25, 45],
    ['ghost', 83, 19, 9, 19],
    ['text', 33, 19, 35, 43, 8],
    ['text', 29, 5, 60, 8, 1],
    ['text', 12, 6, 12, 11, 2],
  ],
  'BE-id-back': [
    ['mrz', 5.8, 68.4, 89.6, 20.2, 3],
    ['photo', 30, 18, 22, 40],
    ['chip', 10, 31, 15, 24],
    ['qr', 12, 5, 12, 22],
    ['text', 30, 5, 28, 9, 1],
  ],
  'BE-passport': [
    ['mrz', 5.4, 81.4, 89.8, 10.5, 2],
    ['photo', 3, 17, 28, 53],
    ['text', 34, 15, 36, 50, 10],
    ['text', 30, 5, 60, 7, 1],
    ['text', 3, 7, 12, 7, 1],
    ['text', 83, 67, 12, 6, 1],
  ],
  'BG-id-back': [
    ['mrz', 5.1, 67.9, 88.4, 20.5, 3],
    ['photo', 83, 35, 12, 24],
    ['text', 3, 6, 70, 40, 8],
  ],
  'BG-passport': [
    ['mrz', 5, 79, 90.3, 9.9, 2],
    ['photo', 5, 24, 25, 45],
    ['text', 33, 15, 44, 52, 10],
    ['text', 31, 6, 57, 4, 1],
    ['text', 9, 11, 15, 8, 1],
  ],
  'BH-id-back': [
    ['photo', 10.5, 12.5, 10, 14],
    ['text', 54, 12, 40, 55, 8],
    ['mrz', 5.5, 74, 87, 22, 3],
  ],
  'BH-passport-prado': [
    ['mrz', 3.5, 77.3, 92.6, 13, 2],
    ['photo', 5.1, 24.3, 27.1, 49],
    ['ghost', 65, 33.3, 14, 26.6],
    ['text', 33.5, 18.9, 62.5, 52.2, 13],
  ],
  'BR-id-back': [
    ['mrz', 6.5, 72, 87.4, 18.9, 3],
    ['qr', 5, 12, 23, 40],
    ['text', 31, 9, 29, 22, 3],
    ['text', 31, 38, 54, 10, 2],
  ],
  'BR-passport': [
    ['mrz', 4.4, 80.4, 91.6, 8.4, 2],
    ['photo', 3, 18, 27, 48],
    ['text', 33, 13, 34, 60, 10],
    ['text', 70, 65, 21, 12, 2],
    ['text', 70, 10, 27, 22, 3],
    ['text', 70, 56, 21, 6, 1],
  ],
  'BY-id-back': [
    ['mrz', 6, 69.2, 87.6, 20.6, 3],
    ['photo', 75, 4, 14, 26],
    ['chip', 10, 31, 15, 19],
    ['text', 29, 38, 34, 18, 3],
    ['text', 29, 6, 22, 18, 3],
  ],
  'BY-passport': [
    ['mrz', 4.9, 82.7, 90, 9.2, 2],
    ['photo', 4, 35, 26, 41],
    ['ghost', 81, 31, 10, 15],
    ['text', 33, 21, 46, 58, 11],
  ],
  'CA-passport': [
    ['mrz', 4.8, 80.7, 89.4, 10.2, 2],
    ['photo', 4, 17, 40, 53],
    ['ghost', 67, 59, 9, 16],
    ['text', 47, 12, 45, 44, 8],
    ['text', 10, 6, 14, 6, 1],
  ],
  'CH-id-back': [
    ['mrz', 5.4, 68.6, 92.6, 20.2, 3],
    ['ghost', 19, 23, 12, 24],
    ['text', 6, 6, 30, 14, 2],
    ['text', 6, 51, 30, 10, 2],
    ['text', 51, 51, 30, 10, 2],
  ],
  'CH-passport': [
    ['mrz', 4.8, 80.7, 90, 10, 2],
    ['photo', 3, 27, 28, 47],
    ['ghost', 83, 32, 10, 17],
    ['text', 34, 9, 47, 62, 12],
    ['text', 3, 8, 16, 14, 2],
  ],
  'CL-id-back': [
    ['mrz', 5.8, 67.1, 88.1, 20.3, 3],
    ['qr', 5, 8, 17, 31],
    ['text', 5, 42, 40, 8, 1],
  ],
  'CL-passport': [
    ['mrz', 3, 81.8, 93.6, 9.9, 2],
    ['photo', 2, 14, 28, 50],
    ['text', 33, 11, 59, 58, 10],
  ],
  'CN-passport': [
    ['mrz', 4.8, 80.2, 89.1, 9.4, 2],
    ['ghost', 81, 21, 13, 32],
    ['text', 32, 19, 46, 40, 8],
  ],
  'CO-cedula-back': [
    ['barcode', 12, 3.5, 83.3, 30.1],
    ['text', 12.6, 37, 57, 18, 4],
    ['mrz', 4.5, 64.7, 90.7, 26.1, 3],
  ],
  'CO-id-back': [
    ['mrz', 8.1, 69.8, 85.9, 20.1, 3],
    ['qr', 67, 8, 28, 45],
    ['text', 41, 53, 19, 8, 1],
    ['text', 8, 8, 2, 24, 1],
  ],
  'CO-passport': [
    ['mrz', 5, 82, 89.9, 9.6, 2],
    ['photo', 4, 19, 25, 50],
    ['text', 32, 11, 56, 58, 11],
  ],
  'CR-passport-prado': [
    ['mrz', 4.7, 77.3, 90.6, 13.7, 2],
    ['photo', 7.2, 14.3, 20.4, 47.9],
    ['text', 32, 6.5, 64, 37.6, 13],
    ['barcode', 36, 48, 61, 22],
  ],
  'CU-passport-prado': [
    ['mrz', 3.3, 78.4, 94, 14.2, 2],
    ['photo', 2, 23.1, 29.2, 53.9],
    ['text', 31.9, 12.4, 64.1, 57.4, 14],
  ],
  'CY-id-back': [
    ['mrz', 5.1, 69.2, 87.8, 19.1, 3],
    ['text', 4, 3, 40, 48, 9],
    ['text', 52, 3, 38, 50, 8],
  ],
  'CY-passport': [
    ['mrz', 4.3, 82, 90.6, 10.2, 2],
    ['photo', 4, 21, 25, 48],
    ['ghost', 86, 22, 10, 23],
    ['text', 32, 16, 52, 55, 11],
    ['text', 4, 6, 76, 7, 1],
  ],
  'CZ-id-back': [
    ['mrz', 4.9, 69.3, 89.6, 19.5, 3],
    ['chip', 10, 32, 16, 22],
    ['barcode', 92, 12, 6, 48],
    ['text', 5, 3, 45, 26, 5],
    ['text', 29, 32, 23, 11, 2],
  ],
  'CZ-passport': [
    ['mrz', 5.8, 80.6, 87.1, 9.6, 2],
    ['photo', 5, 15, 27, 45],
    ['ghost', 82, 26, 13, 14],
    ['text', 35, 11, 44, 56, 11],
  ],
  'DE-id-back': [
    ['mrz', 6, 68.7, 88.4, 20.2, 3],
    ['photo', 29, 17, 11, 17],
    ['text', 4, 4, 22, 36, 6],
    ['text', 45, 4, 25, 22, 4],
    ['text', 45, 32, 28, 15, 3],
  ],
  'DE-passport': [
    ['mrz', 4.6, 82.4, 91, 8.6, 2],
    ['photo', 3, 27, 30, 45],
    ['text', 36, 27, 42, 45, 9],
    ['text', 12, 15, 45, 8, 1],
    ['text', 60, 16, 21, 8, 1],
  ],
  'DK-passport': [
    ['mrz', 5.6, 80.3, 90.1, 10.1, 2],
    ['photo', 4, 16, 24, 48],
    ['text', 31, 11, 59, 56, 11],
  ],
  'DO-passport-prado': [
    ['mrz', 3.6, 82.3, 91, 13.2, 2],
    ['photo', 4.4, 19.4, 27.1, 48.6],
    ['ghost', 82, 33.5, 9, 16.7],
    ['text', 35.5, 12.4, 60.5, 57.8, 14],
  ],
  'DZ-id-back': [
    ['mrz', 8.1, 66.8, 84, 17.5, 3],
    ['photo', 56, 39, 12, 17],
    ['chip', 12, 31, 16, 22],
    ['text', 7, 8, 25, 15, 2],
    ['text', 35, 33, 10, 8, 1],
  ],
  'DZ-passport': [
    ['mrz', 4.9, 74.4, 89.4, 9.6, 2],
    ['photo', 4, 18, 22, 41],
    ['text', 31, 6, 55, 56, 11],
    ['text', 5, 64, 23, 6, 1],
    ['text', 5, 6, 18, 6, 1],
  ],
  'EC-id-back': [
    ['mrz', 7.2, 72.7, 90.3, 18.4, 3],
    ['barcode', 5, 6, 4, 50],
    ['text', 15, 6, 43, 55, 9],
    ['text', 74, 6, 22, 45, 8],
  ],
  'EC-passport-prado': [
    ['mrz', 4.3, 80.2, 90.8, 13.8, 2],
    ['photo', 4.1, 19.2, 25.2, 45.8],
    ['ghost', 59, 18.1, 11.5, 24],
    ['text', 31.8, 6.7, 64.2, 41.5, 11],
    ['barcode', 29, 53, 70, 21],
  ],
  'EE-id-back': [
    ['mrz', 6.5, 68.6, 87.1, 20.4, 3],
    ['photo', 51, 25, 13, 22],
    ['chip', 10, 31, 14, 27],
    ['qr', 3, 5, 13, 23],
    ['barcode', 67, 48, 31, 6],
    ['barcode', 67, 19, 31, 5],
    ['text', 67, 27, 25, 18, 3],
    ['text', 4, 35, 3, 15, 1],
  ],
  'EE-passport': [
    ['mrz', 5.1, 80, 89.1, 10.1, 2],
    ['photo', 8, 23, 24, 48],
    ['text', 35, 12, 43, 62, 12],
  ],
  'EG-passport-prado': [
    ['mrz', 4.5, 79.1, 91.2, 13.6, 2],
    ['photo', 4.3, 14.9, 27.4, 47.8],
    ['ghost', 37.4, 52.1, 12.8, 21.3],
    ['text', 37.4, 12.3, 58.6, 52.1, 9],
    ['barcode', 2, 63, 30, 12],
  ],
  'ES-id-back': [
    ['mrz', 5.6, 67.6, 88.3, 20.5, 3],
    ['chip', 11, 31, 15, 22],
    ['text', 29, 32, 24, 17, 3],
    ['text', 28, 5, 25, 15, 3],
    ['text', 2, 30, 4, 18, 1],
  ],
  'ES-passport': [
    ['mrz', 5.5, 80, 89.8, 10.4, 2],
    ['photo', 3, 22, 28, 48],
    ['text', 34, 10, 63, 60, 12],
    ['text', 5, 3, 45, 4, 1],
  ],
  'ES-tie-back': [
    ['photo', 7.5, 10, 10.5, 21],
    ['text', 23, 16, 48, 17, 4],
    ['text', 6, 33, 30, 20, 4],
    ['mrz', 5.4, 66.7, 90, 23.4, 3],
  ],
  'FI-id-back': [
    ['mrz', 6.4, 67.7, 91.4, 19.4, 3],
    ['photo', 41, 15, 25, 34],
    ['chip', 9, 31, 17, 22],
    ['qr', 81, 5, 15, 23],
    ['text', 69, 34, 24, 24, 4],
    ['text', 4, 6, 28, 14, 2],
  ],
  'FI-passport': [
    ['mrz', 5.4, 79.3, 88.5, 9.8, 2],
    ['photo', 3, 21, 27, 47],
    ['ghost', 33, 34, 10, 17],
    ['text', 46, 12, 31, 52, 10],
    ['text', 4, 7, 30, 5, 1],
  ],
  'FR-id-back': [
    ['mrz', 6.9, 69.4, 87.3, 19.8, 3],
    ['photo', 79, 12, 12, 17],
    ['chip', 10, 31, 15, 22],
    ['text', 28, 15, 29, 17, 3],
    ['text', 27, 6, 41, 6, 1],
  ],
  'FR-id-paper-front': [
    ['text', 3, 14, 52, 4, 1],
    ['photo', 2.8, 19, 26.2, 52.8],
    ['text', 33, 19, 55, 33, 5],
    ['mrz', 5.8, 75.1, 86.2, 16.1, 2],
  ],
  'FR-passport': [
    ['mrz', 5.1, 81.6, 93.5, 10.4, 2],
    ['photo', 4, 22, 28, 48],
    ['ghost', 39, 15, 19, 35],
    ['text', 61, 10, 27, 60, 12],
    ['text', 3, 6, 18, 6, 1],
  ],
  'GB-passport': [
    ['mrz', 5, 79.1, 90.1, 10.3, 2],
    ['photo', 3, 20, 30, 50],
    ['ghost', 79, 26, 9, 15],
    ['text', 36, 11, 41, 58, 11],
    ['text', 9, 11, 13, 6, 1],
  ],
  'GE-id-back': [
    ['mrz', 6.8, 68.1, 86.9, 20, 3],
    ['photo', 81, 29, 12, 22],
    ['chip', 10, 31, 15, 24],
    ['qr', 64, 29, 13, 22],
    ['text', 29, 17, 32, 35, 6],
  ],
  'GE-passport': [
    ['mrz', 5.1, 82.4, 91.9, 9.5, 2],
    ['photo', 7, 30, 28, 40],
    ['text', 38, 23, 18, 52, 8],
    ['text', 61, 23, 25, 48, 6],
    ['text', 4, 16, 16, 11, 2],
  ],
  'GR-id-back': [
    ['mrz', 5.8, 67.1, 88.9, 21.9, 3],
    ['text', 7, 12, 30, 45, 6],
    ['text', 72, 23, 22, 22, 4],
  ],
  'GR-passport': [
    ['mrz', 4.9, 80.8, 89.8, 10.2, 2],
    ['photo', 4, 23, 24, 45],
    ['ghost', 83, 48, 11, 18],
    ['text', 31, 10, 50, 60, 12],
    ['text', 9, 3, 15, 8, 1],
  ],
  'HR-id-back': [
    ['mrz', 6, 69.6, 87, 19.4, 3],
    ['chip', 11, 34, 12, 25],
    ['text', 28, 7, 46, 55, 8],
  ],
  'HR-passport': [
    ['mrz', 5.9, 77.6, 87.5, 9.9, 2],
    ['photo', 2, 28, 25, 42],
    ['text', 30, 15, 48, 55, 11],
    ['text', 4, 4, 92, 8, 1],
  ],
  'HU-id-back': [
    ['mrz', 4.6, 67.3, 90.1, 19.3, 3],
    ['qr', 73, 8, 13, 28],
    ['text', 5, 6, 50, 52, 7],
    ['text', 73, 48, 24, 5, 1],
  ],
  'HU-passport': [
    ['mrz', 4.3, 79.9, 93.9, 9.7, 2],
    ['photo', 3, 21, 26, 52],
    ['text', 32, 12, 24, 61, 12],
    ['text', 65, 41, 28, 22, 4],
    ['text', 4, 9, 19, 9, 1],
    ['text', 65, 9, 18, 7, 1],
  ],
  'IE-passport': [
    ['mrz', 4.9, 80, 90.1, 10.7, 2],
    ['photo', 5, 17, 23, 41],
    ['text', 31, 7, 34, 58, 11],
    ['text', 68, 14, 23, 40, 6],
    ['text', 13, 3, 12, 7, 1],
  ],
  'IL-passport': [
    ['mrz', 5.4, 81.6, 89.1, 9.3, 2],
    ['photo', 4, 20, 23, 38],
    ['text', 30, 13, 27, 65, 8],
    ['text', 76, 13, 17, 58, 8],
    ['text', 30, 5, 64, 5, 1],
    ['text', 6, 8, 17, 4, 1],
  ],
  'IN-passport': [
    ['mrz', 3.9, 83.6, 94.5, 10.2, 2],
    ['photo', 4, 15, 26, 43],
    ['text', 34, 19, 30, 52, 10],
    ['text', 33, 9, 63, 7, 1],
    ['text', 70, 63, 25, 10, 2],
    ['text', 30, 2, 40, 4, 1],
  ],
  'IS-id-back': [
    ['mrz', 66, 2, 26, 95, 3],
    ['qr', 4, 3, 43, 32],
    ['text', 5, 38, 45, 37, 7],
  ],
  'IS-passport': [
    ['mrz', 5.3, 79.8, 89.3, 10.3, 2],
    ['photo', 4, 23, 24, 44],
    ['text', 33, 11, 52, 58, 11],
    ['text', 4, 5, 15, 15, 3],
  ],
  'IT-id-back': [
    ['mrz', 6.3, 72.9, 87.1, 19.6, 3],
    ['barcode', 12, 48, 78, 18],
    ['ghost', 83, 14, 12, 23],
    ['text', 5, 6, 40, 33, 6],
    ['text', 48, 16, 17, 6, 1],
  ],
  'IT-passport': [
    ['mrz', 4, 83.2, 92.3, 9.7, 2],
    ['photo', 4, 20, 25, 48],
    ['ghost', 73, 19, 20, 31],
    ['text', 32, 15, 39, 60, 12],
    ['text', 30, 5, 67, 6, 1],
    ['text', 73, 56, 25, 10, 2],
    ['text', 10, 7, 6, 6, 1],
  ],
  'JM-passport-prado': [
    ['mrz', 4.8, 76.9, 91.6, 14.5, 2],
    ['photo', 6.5, 19.4, 23.8, 51.1],
    ['text', 32.6, 10, 63.4, 56.2, 14],
  ],
  'JP-passport': [
    ['mrz', 5.3, 80.1, 89, 10.1, 2],
    ['photo', 3, 26, 25, 47],
    ['text', 33, 13, 45, 58, 11],
    ['text', 7, 11, 22, 6, 1],
  ],
  'KG-passport-prado': [
    ['mrz', 4, 77.1, 91, 13.4, 2],
    ['photo', 3.3, 24.1, 25.3, 45.3],
    ['ghost', 87, 54.1, 8.4, 13.7],
    ['text', 31.2, 15.7, 64.8, 50.7, 14],
  ],
  'KR-passport': [
    ['mrz', 5.6, 79.4, 89, 9.8, 2],
    ['photo', 4, 20, 27, 48],
    ['ghost', 77, 35, 10, 22],
    ['text', 35, 19, 39, 52, 10],
    ['text', 6, 9, 38, 6, 1],
  ],
  'KW-passport-prado': [
    ['mrz', 0.3, 79, 94.7, 11.6, 2],
    ['ghost', 74, 42.6, 8, 14.2],
    ['photo', 5, 15, 21, 40],
    ['text', 26, 11, 72, 62, 10],
  ],
  'KZ-passport-prado': [
    ['mrz', 4.7, 76.1, 89.5, 14.2, 2],
    ['photo', 5.1, 21.2, 23.2, 43.7],
    ['text', 31.2, 6.7, 64.8, 60.2, 14],
  ],
  'LI-id-back': [
    ['mrz', 3.9, 68.2, 94, 20.9, 3],
    ['chip', 10, 33, 15, 22],
    ['text', 33, 25, 48, 28, 5],
    ['text', 33, 4, 12, 10, 2],
  ],
  'LI-passport': [
    ['mrz', 4.6, 85.5, 91.9, 8.9, 2],
    ['photo', 4, 31, 22, 41],
    ['text', 31, 23, 50, 52, 10],
    ['text', 12, 15, 28, 5, 1],
  ],
  'LT-id-back': [
    ['mrz', 7.6, 66.9, 85.9, 21.7, 3],
    ['chip', 10, 31, 15, 22],
    ['barcode', 29, 32, 42, 17],
    ['ghost', 78, 29, 12, 20],
    ['text', 16, 7, 40, 13, 2],
  ],
  'LT-passport': [
    ['mrz', 6.6, 82.5, 88.6, 10.4, 2],
    ['photo', 3, 20, 28, 50],
    ['ghost', 85, 26, 10, 20],
    ['text', 34, 17, 49, 55, 11],
    ['text', 4, 7, 12, 10, 2],
  ],
  'LU-id-back': [
    ['mrz', 5.3, 67.8, 87.6, 20.7, 3],
    ['ghost', 72, 33, 16, 18],
    ['text', 18, 13, 43, 13, 2],
    ['text', 30, 45, 31, 12, 2],
  ],
  'LU-passport': [
    ['mrz', 4.6, 82.1, 90.1, 9.5, 2],
    ['photo', 5, 31, 23, 38],
    ['text', 31, 17, 44, 61, 12],
    ['text', 13, 9, 35, 5, 1],
    ['text', 78, 62, 10, 6, 1],
  ],
  'LV-id-back': [
    ['mrz', 3.8, 67.8, 91.3, 20.3, 3],
    ['chip', 9, 29, 16, 24],
    ['qr', 85, 5, 10, 17],
    ['ghost', 41, 39, 10, 17],
    ['text', 28, 3, 38, 20, 4],
    ['text', 3, 3, 20, 22, 4],
  ],
  'LV-passport': [
    ['mrz', 3.8, 81.6, 91.3, 9.9, 2],
    ['photo', 3, 20, 25, 44],
    ['ghost', 79, 37, 12, 18],
    ['text', 31, 15, 46, 48, 9],
    ['text', 31, 8, 41, 4, 1],
    ['text', 3, 10, 14, 7, 1],
  ],
  'MA-id-back': [
    ['mrz', 4.4, 69.9, 91.6, 19.9, 3],
    ['text', 3, 43, 92, 17, 2],
    ['text', 51, 13, 25, 12, 2],
    ['text', 30, 5, 40, 5, 1],
    ['text', 3, 28, 30, 8, 1],
    ['text', 3, 5, 22, 5, 1],
    ['text', 84, 5, 13, 5, 1],
  ],
  'MA-passport': [
    ['mrz', 6.6, 80.2, 89.8, 9.6, 2],
    ['photo', 3, 18, 27, 43],
    ['text', 33, 10, 61, 67, 13],
    ['text', 2, 5, 28, 6, 1],
    ['text', 6, 64, 18, 7, 1],
  ],
  'MC-id-back': [
    ['mrz', 5.8, 65.9, 89.9, 22, 3],
    ['text', 4, 5, 22, 34, 6],
    ['text', 8, 44, 30, 10, 2],
    ['text', 29, 24, 16, 13, 2],
    ['text', 29, 5, 30, 6, 1],
  ],
  'MC-passport': [
    ['mrz', 6.9, 83.4, 89.1, 10, 2],
    ['photo', 7, 21, 28, 53],
    ['text', 38, 24, 31, 52, 10],
    ['text', 38, 16, 54, 5, 1],
    ['text', 72, 61, 24, 5, 1],
    ['text', 7, 10, 18, 7, 1],
  ],
  'MD-id-back': [
    ['mrz', 5.5, 69.3, 89.1, 20.1, 3],
    ['chip', 11, 34, 15, 20],
    ['qr', 61, 31, 15, 23],
    ['barcode', 79, 46, 18, 10],
    ['ghost', 32, 45, 14, 18],
    ['ghost', 84, 15, 9, 24],
    ['text', 29, 8, 29, 32, 6],
  ],
  'MD-passport': [
    ['mrz', 4.5, 83.6, 91.3, 9.1, 2],
    ['photo', 3, 32, 25, 41],
    ['text', 31, 24, 62, 56, 11],
    ['text', 31, 15, 62, 6, 1],
    ['text', 6, 14, 16, 10, 2],
  ],
  'ME-id-back': [
    ['mrz', 5.3, 68.7, 89.5, 20.4, 3],
    ['chip', 10, 33, 15, 22],
    ['text', 28, 30, 42, 23, 4],
  ],
  'ME-passport': [
    ['mrz', 4.8, 80.3, 90.3, 9.8, 2],
    ['photo', 2, 20, 27, 50],
    ['text', 32, 13, 62, 60, 12],
    ['text', 31, 6, 25, 4, 1],
    ['text', 20, 13, 9, 4, 1],
  ],
  'MK-id-back': [
    ['mrz', 6.6, 68.2, 87.4, 21.1, 3],
    ['text', 7, 28, 40, 16, 3],
    ['text', 7, 47, 45, 6, 1],
    ['text', 7, 7, 40, 8, 1],
    ['text', 7, 18, 40, 7, 1],
    ['text', 7, 56, 28, 8, 1],
  ],
  'MK-passport': [
    ['mrz', 7, 81.9, 83.8, 9.6, 2],
    ['photo', 4, 21, 34, 48],
    ['text', 41, 20, 31, 52, 10],
    ['text', 41, 12, 51, 5, 1],
  ],
  'MT-id-back': [
    ['mrz', 5.4, 69.5, 90.8, 19.9, 3],
    ['qr', 54, 10, 10, 20],
    ['ghost', 75, 31, 15, 26],
    ['text', 2, 24, 35, 25, 5],
    ['text', 2, 6, 45, 10, 2],
    ['text', 55, 50, 17, 5, 1],
  ],
  'MT-passport': [
    ['mrz', 4.9, 78.4, 91.8, 10, 2],
    ['photo', 5, 25, 26, 48],
    ['ghost', 86, 19, 9, 16],
    ['text', 34, 10, 50, 50, 10],
    ['text', 19, 3, 10, 10, 2],
  ],
  'MV-passport-prado': [
    ['mrz', 2.7, 80.3, 92.7, 14.2, 2],
    ['photo', 3, 25.1, 24.6, 42.9],
    ['ghost', 83, 20.8, 6, 10.3],
    ['text', 30.5, 10, 65.5, 57.4, 13],
  ],
  'MX-id-back': [
    ['mrz', 8.8, 75.3, 81.5, 18, 3],
    ['photo', 72, 22, 8, 18],
    ['barcode', 4, 5, 18, 7],
    ['text', 74, 58, 19, 10, 2],
  ],
  'MX-passport': [
    ['mrz', 5.5, 83, 89, 10.4, 2],
    ['photo', 3, 24, 30, 50],
    ['ghost', 64, 20, 13, 32],
    ['text', 36, 12, 26, 60, 12],
  ],
  'MY-passport': [
    ['mrz', 4.5, 78.5, 90.5, 9.3, 2],
    ['photo', 4, 19, 34, 46],
    ['text', 41, 17, 55, 50, 10],
    ['text', 31, 6, 65, 8, 1],
    ['text', 5, 10, 17, 6, 1],
  ],
  'NL-id-back': [
    ['mrz', 5.6, 68.6, 88.1, 20.6, 3],
    ['qr', 9, 38, 11, 15],
    ['text', 30, 40, 60, 20, 4],
    ['text', 72, 14, 22, 17, 3],
    ['text', 4, 14, 25, 14, 2],
    ['text', 4, 5, 35, 4, 1],
  ],
  'NL-passport': [
    ['mrz', 5, 80.9, 92.9, 10.5, 2],
    ['photo', 3, 19, 26, 53],
    ['text', 32, 13, 34, 50, 10],
    ['text', 69, 13, 25, 50, 10],
    ['text', 31, 5, 65, 5, 1],
    ['text', 3, 5, 12, 5, 1],
  ],
  'NO-id-back': [
    ['mrz', 5.3, 68.6, 88.8, 20.4, 3],
    ['photo', 17, 30, 13, 25],
    ['ghost', 49, 25, 20, 22],
    ['text', 3, 3, 40, 10, 2],
    ['text', 47, 53, 50, 4, 1],
  ],
  'NO-passport': [
    ['mrz', 4.9, 79.2, 88.4, 10.3, 2],
    ['photo', 6, 22, 34, 48],
    ['text', 43, 15, 48, 55, 11],
    ['text', 31, 3, 60, 7, 1],
    ['text', 3, 3, 10, 15, 3],
  ],
  'NP-passport-prado': [
    ['mrz', 3.2, 80.9, 92, 13.2, 2],
    ['photo', 4.7, 24.6, 21.4, 36],
    ['ghost', 85.9, 42.1, 5.8, 9.5],
    ['text', 27.9, 15.8, 68.1, 54.3, 12],
  ],
  'NZ-passport-prado': [
    ['mrz', 2.9, 78.3, 92.7, 13.8, 2],
    ['photo', 2, 21.3, 30, 48.6],
    ['ghost', 82.2, 33.5, 9.6, 17],
    ['text', 33.8, 11.6, 62.2, 58.1, 12],
  ],
  'OM-passport-prado': [
    ['mrz', 3.7, 79.3, 90.7, 13.2, 2],
    ['photo', 7.2, 27.2, 19.7, 38.3],
    ['ghost', 61.4, 44.1, 11.4, 22.1],
    ['text', 30.1, 12.6, 65.9, 54, 10],
  ],
  'PA-passport-prado': [
    ['mrz', 4.2, 79.6, 92.6, 13.5, 2],
    ['photo', 4.4, 19.8, 22.8, 39.6],
    ['ghost', 88.2, 32.7, 7.7, 14.2],
    ['text', 30.1, 10.3, 65.9, 56.2, 13],
  ],
  'PE-id-back': [
    ['mrz', 6.4, 68.8, 87.4, 20.7, 3],
    ['chip', 11, 34, 14, 22],
    ['barcode', 90, 7, 8, 38],
    ['qr', 12, 8, 13, 22],
    ['text', 28, 5, 25, 50, 10],
    ['text', 67, 54, 20, 6, 1],
  ],
  'PE-passport': [
    ['mrz', 4.5, 80, 92.3, 11.3, 2],
    ['photo', 2, 17, 29, 54],
    ['ghost', 80, 22, 12, 24],
    ['text', 34, 15, 37, 55, 11],
    ['text', 32, 3, 40, 6, 1],
    ['text', 3, 4, 10, 7, 1],
  ],
  'PH-passport-prado': [
    ['mrz', 4.3, 79.9, 91.2, 13.9, 2],
    ['photo', 5.1, 20.7, 26, 48.4],
    ['text', 33.8, 11.8, 62.2, 60.7, 13],
  ],
  'PL-id-back': [
    ['mrz', 5.5, 69, 88.4, 19.6, 3],
    ['photo', 85, 25, 13, 21],
    ['barcode', 37, 5, 22, 13],
    ['text', 3, 28, 40, 25, 5],
    ['text', 3, 5, 30, 20, 4],
    ['text', 68, 31, 14, 16, 3],
    ['text', 65, 5, 28, 10, 2],
  ],
  'PL-passport': [
    ['mrz', 5.1, 82.6, 89, 10.8, 2],
    ['photo', 3, 24, 28, 48],
    ['text', 34, 10, 56, 55, 11],
    ['text', 3, 2, 70, 4, 1],
    ['text', 3, 10, 15, 6, 1],
  ],
  'PT-id-back': [
    ['mrz', 6.9, 68.1, 86.3, 19, 3],
    ['photo', 4, 3, 12, 22],
    ['chip', 11, 32, 15, 22],
    ['text', 29, 43, 62, 14, 2],
    ['text', 27, 16, 40, 10, 2],
    ['text', 27, 3, 36, 5, 1],
  ],
  'PT-passport': [
    ['mrz', 5.5, 80.1, 88.5, 9.9, 2],
    ['photo', 4, 22, 26, 52],
    ['text', 33, 10, 27, 60, 12],
    ['text', 63, 10, 34, 52, 8],
  ],
  'PY-passport-prado': [
    ['mrz', 3.3, 78.1, 91.3, 14.3, 2],
    ['photo', 6.6, 26.3, 21.3, 48.5],
    ['ghost', 86.2, 18.7, 7.6, 12.3],
    ['text', 31.8, 15.5, 64.2, 56.1, 13],
  ],
  'QA-passport-prado': [
    ['mrz', 4.2, 79.4, 89, 12.9, 2],
    ['photo', 5.1, 22.4, 26.8, 46.9],
    ['text', 34.5, 20, 61.5, 47.6, 11],
    ['ghost', 57, 39, 10, 25],
  ],
  'RO-id-back': [
    ['mrz', 6.3, 66.8, 88.1, 21, 3],
    ['photo', 75, 16, 15, 17],
    ['chip', 10, 31, 15, 24],
    ['text', 29, 33, 36, 19, 3],
  ],
  'RO-id-classic-front': [
    ['text', 29, 12, 40, 8, 2],
    ['photo', 2, 12, 25.8, 50.4],
    ['text', 29, 21, 25, 50, 7],
    ['ghost', 82.5, 18, 14, 23],
    ['mrz', 3.9, 75.3, 90, 14.6, 2],
  ],
  'RO-passport': [
    ['mrz', 6.6, 80.9, 89.5, 10, 2],
    ['photo', 4, 28, 33, 43],
    ['text', 40, 8, 35, 65, 13],
  ],
  'RS-id-back': [
    ['mrz', 5.1, 68.4, 88.3, 20.8, 3],
    ['chip', 10, 33, 15, 24],
    ['ghost', 7, 12, 10, 15],
    ['text', 28, 16, 44, 48, 6],
  ],
  'RS-passport': [
    ['mrz', 4.9, 79.8, 93.8, 10.3, 2],
    ['photo', 4, 28, 27, 46],
    ['chip', 54, 63, 9, 8],
    ['text', 34, 10, 46, 50, 10],
  ],
  'RU-passport': [
    ['mrz', 5.1, 79.7, 88.8, 10.2, 2],
    ['photo', 3, 22, 24, 48],
    ['text', 30, 10, 32, 60, 12],
    ['text', 65, 10, 27, 56, 8],
  ],
  'SA-passport-prado': [
    ['mrz', 4, 76, 90.8, 13, 2],
    ['photo', 3.2, 29.4, 24.3, 36.2],
    ['ghost', 79, 41.2, 8.6, 15.3],
    ['text', 29.9, 16.9, 66.1, 51.8, 10],
  ],
  'SC-passport-prado': [
    ['mrz', 2.7, 83, 92, 14.6, 2],
    ['photo', 4.4, 18.1, 27.5, 55.8],
    ['ghost', 72.8, 17, 14.2, 30.9],
    ['text', 34.5, 11.1, 61.5, 53.8, 14],
  ],
  'SE-id-back': [
    ['mrz', 4.6, 68.3, 91, 19.8, 3],
    ['text', 5, 10, 30, 35, 6],
  ],
  'SE-passport': [
    ['mrz', 4.5, 80.4, 90.6, 9.6, 2],
    ['photo', 4, 26, 25, 46],
    ['ghost', 62, 32, 9, 16],
    ['text', 32, 5, 28, 65, 12],
    ['text', 76, 38, 18, 20, 4],
    ['text', 3, 5, 12, 10, 2],
  ],
  'SG-passport-prado': [
    ['mrz', 5.6, 77.4, 87.8, 13.8, 2],
    ['photo', 3.9, 26.6, 22.6, 39.1],
    ['ghost', 84, 33, 9.6, 18.2],
    ['text', 30.4, 15.3, 65.6, 55.1, 13],
  ],
  'SI-id-back': [
    ['mrz', 5.8, 70.2, 87.6, 20, 3],
    ['chip', 10, 31, 16, 26],
    ['qr', 83, 6, 13, 25],
    ['ghost', 4, 7, 14, 20],
    ['ghost', 81, 42, 14, 20],
    ['text', 29, 25, 28, 22, 3],
    ['text', 29, 50, 35, 5, 1],
  ],
  'SI-passport': [
    ['mrz', 5.9, 78.6, 86.8, 8.8, 2],
    ['photo', 6, 25, 32, 44],
    ['ghost', 75, 22, 13, 16],
    ['text', 41, 12, 32, 60, 12],
  ],
  'SK-id-back': [
    ['mrz', 6.4, 68.7, 87.6, 20.1, 3],
    ['chip', 10, 31, 15, 24],
    ['text', 30, 6, 45, 38, 6],
  ],
  'SK-passport': [
    ['mrz', 5.4, 80, 88.3, 10.1, 2],
    ['photo', 4, 20, 30, 45],
    ['text', 37, 5, 43, 70, 14],
  ],
  'SM-id-back': [
    ['mrz', 5.8, 70.9, 88.8, 20.4, 3],
    ['text', 40, 3, 57, 45, 8],
  ],
  'SM-passport-prado': [
    ['mrz', 4.6, 80.2, 89.1, 13, 2],
    ['photo', 5.7, 23.2, 22.2, 39.6],
    ['ghost', 82, 31.5, 9.2, 15.6],
    ['text', 30.2, 8.8, 65.8, 54.5, 13],
  ],
  'TH-passport': [
    ['mrz', 4.6, 81.9, 88.5, 9.5, 2],
    ['photo', 5, 34, 22, 36],
    ['text', 30, 12, 65, 60, 12],
  ],
  'TN-passport': [
    ['mrz', 5.8, 84.7, 89.1, 9.6, 2],
    ['photo', 4, 27, 22, 47],
    ['barcode', 32, 68, 59, 11],
    ['ghost', 74, 27, 17, 31],
    ['text', 30, 13, 41, 52, 10],
  ],
  'TR-id-back': [
    ['mrz', 6.4, 67.6, 87.6, 23.4, 3],
    ['chip', 10, 31, 15, 25],
    ['barcode', 48, 3, 35, 10],
    ['text', 28, 18, 38, 34, 6],
  ],
  'TR-passport': [
    ['mrz', 4.5, 80.6, 91, 10, 2],
    ['photo', 4, 29, 24, 41],
    ['text', 31, 19, 23, 48, 9],
    ['text', 28, 12, 40, 4, 1],
  ],
  'UA-id-back': [
    ['mrz', 4.5, 69.4, 89.4, 19.2, 3],
    ['photo', 80, 13, 13, 31],
    ['text', 4, 10, 30, 30, 6],
    ['text', 50, 10, 15, 8, 1],
  ],
  'UA-passport': [
    ['mrz', 5, 80.5, 90.9, 10.6, 2],
    ['photo', 5, 29, 25, 41],
    ['text', 33, 10, 57, 63, 12],
  ],
  'US-dl-back': [
    ['barcode', 29, 1, 58, 8],
    ['barcode', 34, 11, 53, 31.5],
    ['text', 4, 6, 17, 16, 3],
    ['text', 4, 50, 40, 10, 3],
  ],
  'US-passport': [
    ['mrz', 3.1, 85.4, 93.9, 10.1, 2],
    ['photo', 3, 30, 26, 42],
    ['ghost', 81, 66, 12, 14],
    ['text', 32, 25, 26, 52, 10],
    ['text', 31, 14, 60, 8, 1],
  ],
  'UY-passport-prado': [
    ['mrz', 3, 80.6, 92.1, 14, 2],
    ['photo', 5.6, 27.3, 25.6, 37.1],
    ['ghost', 52, 14.2, 15, 25.6],
    ['text', 31.9, 8, 64.1, 56.7, 13],
  ],
  'UZ-passport-prado': [
    ['mrz', 5.3, 78.8, 90.5, 13.9, 2],
    ['photo', 4.4, 22.5, 25.9, 46.9],
    ['text', 33.6, 16.1, 62.4, 50.8, 9],
  ],
  'VA-passport': [
    ['mrz', 6.8, 77.9, 85.6, 9.9, 2],
    ['photo', 3, 23, 24, 47],
    ['text', 30, 13, 64, 52, 10],
    ['text', 3, 6, 23, 14, 2],
  ],
  'VE-passport-prado': [
    ['mrz', 2, 78, 93.9, 14.2, 2],
    ['photo', 2.3, 25.8, 27.8, 48.4],
    ['text', 31.8, 12.9, 64.2, 52.5, 14],
  ],
  'VN-passport-prado': [
    ['mrz', 5.2, 82.3, 91.2, 12.9, 2],
    ['photo', 9.4, 30.6, 26.4, 42],
    ['text', 38.5, 19.2, 57.5, 56.5, 12],
  ],
  'XK-id-back': [
    ['mrz', 5.4, 69.6, 89.8, 20.2, 3],
    ['text', 9, 6, 40, 48, 8],
  ],
  'XK-passport': [
    ['mrz', 4.6, 79.9, 89.5, 9.7, 2],
    ['photo', 2, 23, 30, 48],
    ['ghost', 87, 43, 9, 19],
    ['text', 35, 10, 50, 61, 12],
    ['text', 3, 3, 92, 3, 1],
  ],
  'ZA-passport-prado': [
    ['mrz', 3.2, 79.3, 91.9, 13.9, 2],
    ['photo', 4.4, 22.5, 24.3, 43.2],
    ['ghost', 50, 43.8, 15, 28.6],
    ['text', 30.9, 9, 65.1, 56.5, 14],
  ],
  'generic-id-back': [
    ['mrz', 5.1, 69.5, 89, 22.6, 3],
    ['chip', 8, 24, 15, 20],
    ['text', 62, 11, 22, 45, 6],
    ['text', 6, 7, 28, 3, 1],
  ],
  'generic-id-front': [
    ['photo', 3, 19, 30, 62],
    ['ghost', 83, 35, 10, 21],
    ['text', 39, 23, 30, 56, 10],
    ['text', 20, 5, 25, 8, 1],
    ['text', 76, 7, 20, 5, 1],
  ],
  'generic-passport': [
    ['mrz', 1.8, 85.5, 96.5, 7.4, 2],
    ['photo', 10, 32, 24, 46],
    ['ghost', 69, 42, 13, 26],
    ['text', 37, 28, 30, 52, 10],
    ['text', 8, 23, 26, 4, 1],
  ],
};
